export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

// 전화번호 포맷 함수
export const formatPhoneNumber = (value: string): string => {
  const numbersOnly = value.replace(/\D/g, "");

  // 11자리를 초과하면 11자리까지만 자름
  const limitedNumbers = numbersOnly.slice(0, 11);

  if (limitedNumbers.length <= 3) return limitedNumbers;
  if (limitedNumbers.length <= 7)
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3)}`;
  if (limitedNumbers.length <= 11)
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(
      3,
      7
    )}-${limitedNumbers.slice(7, 11)}`;

  return limitedNumbers; // 이 경우는 실제로 발생하지 않음 (위에서 11자리로 제한했으므로)
};
